import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexHelper',
  setup(__props) {

const HelperBorders = defineAsyncComponent(() => import("@/components/theme/uikits/helper/HelperBorders.vue"))
const HelperDisplays = defineAsyncComponent(() => import("@/components/theme/uikits/helper/HelperDisplays.vue"))
const BackgroundColors = defineAsyncComponent(() => import("@/components/theme/uikits/helper/BackgroundColors.vue"))
const BorderColor = defineAsyncComponent(() => import("@/components/theme/uikits/helper/BorderColor.vue"))
const ImagesSizes = defineAsyncComponent(() => import("@/components/theme/uikits/helper/ImagesSizes.vue"))
const FontStyle = defineAsyncComponent(() => import("@/components/theme/uikits/helper/FontStyle.vue"))
const TextColors = defineAsyncComponent(() => import("@/components/theme/uikits/helper/TextColors.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Helper classes",
      title: "Helper classes"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(HelperBorders)),
        _createVNode(_unref(HelperDisplays)),
        _createVNode(_unref(BackgroundColors)),
        _createVNode(_unref(BorderColor)),
        _createVNode(_unref(ImagesSizes)),
        _createVNode(_unref(FontStyle)),
        _createVNode(_unref(TextColors))
      ])
    ])
  ], 64))
}
}

})